export default "__VITE_ASSET__CVLAz9f6__"